import { Suspense, useRef, useState } from "react";
import { useEffect } from "react";
import { getGroups, listSitesWithLiveView } from '../../Api Methods/Api'
import { useDispatch, useSelector } from "react-redux";
import classes from './liveViewSites.module.css'
import Modal from "../../components/Modal/Modal";
import ListCard from "../../components/GridList/ListCard";
import Oval from "react-loading-icons/dist/esm/components/oval";
import { Dropdown } from "primereact/dropdown";
import { Await, Link, useNavigate } from "react-router-dom";
import Pill_Widget from "../../components/UI/Widgets/Pill_Widget";
import useSetCookie from "../../components/hooks/UseSetCookie";
import OutputPinCircle from "../../components/UI/DataLayouts/OutputPinCircle";
import InputPinCircle from "../../components/UI/DataLayouts/InputPinCircle";
import BasicTable from "../../components/Table/Table/Table";
import Stats2 from "../../components/UI/Stats/Stats2";
import DeviceLoadingGrid from "../../components/GridList/DeviceLoadingGrid";
import { Button } from "primereact/button";
import { format } from "date-fns";
import { serviceActions } from "../../store/service-Slice";
import DataManager from "../../hooks/DataManager";
import DevicesList from "../../components/GridList/DevicesList";
import { off } from "rsuite/esm/DOMHelper";

const LiveViewSites = () => {

    const cachedSites = useSelector(state => state.service.LiveViewTableData);
    const [sites, setSites] = useState(cachedSites);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const apiData = {
        token,
        client
    }
    const ModalDialog = useRef();
    const [modalTitle, setModalTitle] = useState("title")
    const [modalComponent, setModalComponent] = useState()
    const loggedInAs = useSelector(state => state.auth.companyName);

    const [groups, setGroups] = useState([])
    const [groupNames, setGroupNames] = useState([])
    
    const dataManager = new DataManager();

    const [siteCount, setSiteCount] = useState(0)
    const [cameraCount, setCameraCount] = useState(0)
    const [totalCameraCount, setTotalCameraCount] = useState(0)
    const [isLoading, setIsLoading] = useState(() => {
      return !cachedSites || cachedSites.length === 0;
    });    
    const [isLoadingStats, setIsLoadingStats] = useState(true);  
    const [online, setOnline] = useState(0)
    const [offline, setOffline] = useState(0)
    const [deviceTag, setDeviceTag] = useState(null)
    const [deviceType, setDeviceType] = useState(0)
    const [groupName, setGroupName] = useState(null)
    const [noTag, setNoTag] = useState(0)

    const [visibleDevices, setVisibleDevices] = useState([]);
    const [page, setPage] = useState(0)

    const [totalPages, setTotalPages] = useState([])
    const [resultCount, setResultCount] = useState(0)
    const [totalDevices, setTotalDevices] = useState([])
    const [pageFetchedIndex, setPageFetchedIndex] = useState(1)
    const [pageSize, setPageSize] = useState(dataManager.getItem('pageSize'))
    const [update, setUpdate] = useState(0)
    const [showMassSettings, setShowMassSettings] = useState(false)
    const [linkedOnly, setLinkedOnly] = useState(false)
    const [pageOffset, setPageOffset] = useState(0)

    const GetGroups = async () => {
      const groups = await getGroups(apiData, dispatch)
      setGroups(groups)
      setGroupNames(groups.map(listOptions => listOptions.name))
    }
  
    useEffect(() => {
      //setIsLoading(true)

      const offset = pageSize * (pageFetchedIndex -1); 
      setPageOffset(offset);
  
      console.log("Offset:", offset);
  
      getLiveViewSites(offset); 
        // pass the computed value
      
  }, [pageSize, pageFetchedIndex, online, offline, deviceTag, groupName]);

  useEffect(() => {
    GetGroups();
  }, [])
  
    const getLiveViewSites = async (offset) => {
        const body = {
            "pageSize": pageSize,
            "pageOffset": offset,
            "online": online, 
            "offline": offline, 
            "deviceTag": deviceTag,
            "groupName": groupName,
            "hasCamerasLinked": 0
        }

        console.log(body)

        const response = await listSitesWithLiveView(apiData, body, dispatch)
        if (response.success){
            console.log(response)
            setSiteCount(response.data[0][0].totalSites)
            setCameraCount(response.data[0][0].withLinkedCamerasCount)
            setTotalCameraCount(response.data[0][0].totalLinkedCameras)
            setSites(response.data[1])
            dispatch(serviceActions.setLiveViewEnabledTableData(response.data[1]));

            setTotalPages(Math.ceil(response.data[0][0].totalSites / pageSize));
            console.log(response.data[1])
            setIsLoading(false)
            setIsLoadingStats(false)
        } else {
          console.log(response)
        }
    }

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
        //setSelectedMassAction("")
    }

    const HandleUipiodOnClick = (DeviceUUID) => {
        dispatch(serviceActions.setDeviceUUID(DeviceUUID));
        useSetCookie("DeviceUUID", DeviceUUID, 1);
        navigate("/Dashboard/SiteView/" + DeviceUUID);
   }

    const HandleGroupOnClick = (groupName) => {
        const groupClicked = groups.find(g => g.name === groupName);
        if (groupClicked) {
            dataManager.setItem('groupClicked', groupClicked.name)   
            dataManager.setItem('groupPath', groupClicked.group_path)
            dataManager.setItem('groupClickedID', groupClicked.id)   
            navigate("/Dashboard/Groups/GroupSites")
        }
    }
  
    const HandleTotalSitesClicked = () => {

    }

    return (
      <Await resolve={sites}>
        {(loadedSites) => {
          return (
            <>
              <div style={{ width: "100%"}}>
                <div style={{ display: "flex", flexDirection: "row", gap: "8px" }}>
                <Stats2
                    title={"Total live view enabled sites"}
                    value={siteCount}
                    isLoadingStats={isLoadingStats}
                    isStatic={true}
                    allSitesFilter={HandleTotalSitesClicked}
                    />

                    <Stats2
                    title={"With a camera linked"}
                    value={cameraCount}
                    isLoadingStats={isLoadingStats}
                    isStatic={true}
                    //setHolidayModeFilter={HandleCamerasClick}
                    />

                    {/* <Stats2
                    title={"Total linked cameras"}
                    value={totalCameraCount}
                    isLoadingStats={isLoading}
                    isStatic={true}
                    setHolidayModeFilter={HandleCamerasClick}
                    />
                    */}
                </div> 
  
                <br></br>
                {isLoading ? (
                  <div style={{ display: "flex", width: "100%" }}>
                    <DeviceLoadingGrid
                      CardCount={
                        20
                      }
                    />
                  </div>
                ) : (
                  <>
                    <div className={classes.searchContainer}>
                      {/* Search bar will go here */}
                      </div>
                      <DevicesList
                        devices={sites}
                        filtering={""}
                        hideControls={false}
                        totalPages={totalPages}
                        setTotalPages={setTotalPages}
                        pageFetchedIndex={pageFetchedIndex}
                        setPageFetchedIndex={setPageFetchedIndex}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                        totalDevices={siteCount}
                        setTotalDevices={setTotalDevices}
                        groupMode={false}
                        update={update}
                        setUpdate={setUpdate}
                        offlineOnly={false}
                        isSortable={true}
                        showMassSelect={true}
                        showMassSettings={showMassSettings}
                        setShowMassSettings={setShowMassSettings}
                        liveViewOnly={true}
                      />
  
                      {/* <BasicTable
                          data={loadedSites}
                          columns={tableColumns}
                          allColumns={tableColumns}
                          filtering={""}
                          rowClick={false}
                          ShowPagination={false}
                          PageSize={50000}
                          paginationOptions={[25, 50, 100]}
                          showFilterButton={false}
                          isSortable={false}
                        /> */}
                  </>
                )}
  
                {/* <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center', 
                  textAlign: 'center',
                  marginTop:"15px"
                }}>
                  <Button style={{width: "30%"}}label="Load more" onClick={HandleLoadMore}/>
                </div> */}
              </div>
            </>
          )
        }}
      </Await>
    )
}

export default LiveViewSites;